<form class="form-horizontal" [formGroup]="pageForm">
  <div class="card-body mb-5">
    <div
      *ngFor="let error of errorsList"
      class="alert alert-danger text-center"
      role="alert"
    >
      {{ error }}
    </div>
    <button
      *ngIf="displayBackButton"
      type="button"
      class="btn bottom-btn btn-primary float-start px-3 mt-3"
      (click)="returnToSearchCriteria()"
    >
      <span class="arrow left float-start">
        <i class="fa fa-chevron-left"></i> </span
      ><span class="float-end">{{ pageText?.lbl_return }}</span>
    </button>
    <div *ngIf="displayBackButton" class="clearfix"></div>

    <div
      *ngIf="!model || model?.length == 0"
      class="text-center"
      style="min-height: 382px"
    >
      <h3 class="mt-5 pt-5">No Records Found.</h3>
    </div>

    <div *ngIf="model?.length > 0">
      <section
        id="details"
        *ngIf="openPanelArr.length > 0"
        [ngClass]="{ 'my-5': model && model?.length > 0 }"
      >
        <table
          *ngIf="displayBackButton"
          class="w-100"
          [mfData]="model"
          #mf="mfDataTable"
          [mfRowsOnPage]="15"
        >
          <tbody>
            <tr>
              <td>
                <div class="pb-5" ngbAccordion [closeOthers]="false">
                  <div
                    ngbAccordionItem
                    *ngFor="let p of mf.data; let i = index"
                    [collapsed]="i !== 0"
                    class="mt-3"
                  >
                    <!-- Accordion Header -->
                    <h2 ngbAccordionHeader>
                      <button ngbAccordionButton>
                        <div class="col-md-2">
                          <h5 class="text-white m-0 float-start">
                            {{ pageText?.lbl_ltf }}
                            <span class="fw-light ms-2">{{ p?.ltfIdNo }}</span>
                          </h5>
                        </div>
                        <div class="col-md-3">
                          <h5 class="text-white m-0 float-start">
                            {{ pageText?.lbl_date_submit
                            }}<span class="fw-light ms-2">{{ p?.submittedDate }}</span>
                          </h5>
                        </div>
                        <div class="col-md-6">
                          <h5 class="text-white m-0 float-start">
                            {{ pageText?.lbl_ltf_status
                            }}<span class="fw-light ms-2">{{ p?.ltfStatus }}</span>
                          </h5>
                        </div>
                      </button>
                    </h2>

                    <!-- Accordion Body -->
                    <div ngbAccordionCollapse>
                      <div ngbAccordionBody>
                        <ng-template>
                          <div class="p-4">

                            <!-- Permit Information -->
                            <h4 class="my-4">{{ pageText?.lbl_permit_info }}</h4>
                            <table class="h5 customtable table">
                              <tbody>
                                <tr>
                                  <td class="fw-normal" style="width: 11.9%">
                                    {{ pageText?.lbl_permit_type }}
                                  </td>
                                  <td class="fw-light ps-2" colspan="3" style="width: 53%">
                                    {{ p?.permitType }}
                                  </td>
                                  <td class="fw-normal">{{ pageText?.lbl_owner_name }}</td>
                                  <td class="fw-light ps-2">{{ p?.ownerRcoName }}</td>
                                </tr>
                                <tr>
                                  <td class="fw-normal">{{ pageText?.lbl_date_applied }}</td>
                                  <td class="fw-light ps-2" style="width: 12.3%">{{ p?.dateApplied }}</td>
                                  <td class="fw-normal" style="width: 16%">{{ pageText?.lbl_company_name }}</td>
                                  <td class="fw-light ps-2">{{ p?.companyName }}</td>
                                  <td class="fw-normal" style="width: 16.6%">{{ pageText?.lbl_project_type }}</td>
                                  <td class="fw-light ps-2">{{ p?.projectType }}</td>
                                </tr>
                                <tr>
                                  <td class="fw-normal">{{ pageText?.lbl_date_issued }}</td>
                                  <td class="fw-light ps-2">{{ p?.issueDate }}</td>
                                  <td class="fw-normal">{{ pageText?.lbl_company_address }}</td>
                                  <td class="fw-light ps-2">
                                    <div *ngIf="p?.companyAddress">
                                      <div>{{ p?.companyAddress }}<span *ngIf="p?.companySuiteApt">, {{ p?.companySuiteApt }}</span></div>
                                      <div>{{ p?.companyCity }}, {{ p?.companyState }} {{ p?.companyZip }}</div>
                                    </div>
                                  </td>
                                  <td class="fw-normal">{{ pageText?.lbl_authcode }}</td>
                                  <td class="fw-light ps-2">{{ p?.authorizationCode }}</td>
                                </tr>
                              </tbody>
                            </table>

                            <hr class="my-3" />

                            <!-- Construction Information -->
                            <h4 class="ps-2 my-4">{{ pageText?.lbl_const_info }}</h4>
                            <table class="h5 ms-2 customtable table">
                              <tbody>
                                <tr>
                                  <td class="fw-normal" style="width: 10.4%">{{ pageText?.lbl_date_start }}</td>
                                  <td class="fw-light ps-2" style="width: 13.5%">{{ p?.startDate }}</td>
                                  <td class="fw-normal" style="width: 16.2%">{{ pageText?.lbl_siteName }}</td>
                                  <td class="fw-light ps-2" style="width: 28%">{{ p?.facilityName }}</td>
                                  <td class="fw-normal" style="width: 20.1%">{{ pageText?.lbl_permit_proj_area }}</td>
                                  <td class="fw-light ps-2">{{ p?.projectAreaAcres }}</td>
                                </tr>
                                <tr>
                                  <td class="fw-normal">{{ pageText?.lbl_date_end }}</td>
                                  <td class="fw-light ps-2">{{ p?.endDate }}</td>
                                  <td></td>
                                  <td></td>
                                  <td class="fw-normal">{{ pageText?.lbl_total_proj_area }}</td>
                                  <td class="fw-light ps-2">{{ p?.totalAreaAcres }}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td class="fw-normal">{{ pageText?.lbl_facility_address }}</td>
                                  <td class="fw-light ps-2">
                                    <div *ngIf="p?.facilityLatitude || p?.facilityLongitude || p?.countyCode">
                                      <div *ngIf="p?.facilityLatitude">{{ pageText?.lbl_lat }}&nbsp;&nbsp;{{ p?.facilityLatitude }}</div>
                                      <div *ngIf="p?.facilityLongitude">{{ pageText?.lbl_lng }}&nbsp;&nbsp;{{ p?.facilityLongitude }}</div>
                                      <div *ngIf="p?.countyCode">{{ pageText?.lbl_facility_county }}&nbsp;{{ utils.countyMap.get(p?.countyCode) || p?.countyCode }}</div>
                                    </div>
                                  </td>
                                  <td class="fw-normal">{{ pageText?.lbl_common_area }}</td>
                                  <td class="fw-light ps-2">
                                    {{ p?.commonArea ? (p?.commonArea === 'Y' ? 'Yes' : 'No') : '' }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <!-- Outfalls -->
                            <h5 class="ms-4 my-4">{{ pageText?.lbl_outfalls }}</h5>
                            <div *ngIf="!p?.outfalls" class="ms-4 w-75 h5 fw-light">N/A</div>
                            <table
                              *ngIf="p?.outfalls"
                              class="table table-striped ms-4 w-75 h5"
                            >
                              <thead>
                                <tr>
                                  <th>{{ pageText?.lbl_lat }}</th>
                                  <th>{{ pageText?.lbl_lng }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let outfall of parseOutfalls(p?.outfalls)">
                                  <td>{{ outfall.lat }}</td>
                                  <td>{{ outfall.lng }}</td>
                                </tr>
                              </tbody>
                            </table>

                            <hr class="my-3" />

                            <!-- SWPPP Information -->
                            <h4 class="ps-2 my-4">{{ pageText?.lbl_swwp_info }}</h4>
                            <table class="h5 ms-2 customtable table">
                              <tbody>
                                <tr>
                                  <td class="fw-normal" style="width: 14%">{{ pageText?.lbl_contact }}</td>
                                  <td class="fw-light ps-2">{{ p?.swpppFirstName }}&nbsp;{{ p?.swpppLastName }}</td>
                                </tr>
                                <tr>
                                  <td class="fw-normal">{{ pageText?.lbl_email }}</td>
                                  <td class="fw-light ps-2">{{ p?.swpppEmail }}</td>
                                </tr>
                                <tr>
                                  <td class="fw-normal">{{ pageText?.lbl_phone }}</td>
                                  <td class="fw-light ps-2">
                                    {{ p?.swpppPhone }}<span *ngIf="p?.swpppExt">&nbsp;Ext: {{ p?.swpppExt }}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <div class="clearfix"></div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td class="pb-0 mb-0 ps-0">
                <div class="pb-0 mb-0 float-end">
                  <mfBootstrapPaginator></mfBootstrapPaginator>
                  <div class="clearfix"></div>
                </div>
                <div class="clearfix"></div>
              </td>
            </tr>
          </tfoot>
        </table>
      </section>
    </div>

    <div class="mt-4">
      <button
        *ngIf="displayBackButton"
        type="button"
        class="btn bottom-btn btn-primary float-start px-3 mb-3"
        (click)="returnToSearchCriteria()"
      >
        <span class="arrow left float-start">
          <i class="fa fa-chevron-left"></i> </span
        ><span class="float-end">{{ pageText?.lbl_return }}</span>
      </button>
    </div>
  </div>
  <div *ngIf="displayBackButton" class="clearfix"></div>
</form>
